import { BillingPlanTier } from '@core/billing-types';
import type { IconToken } from '@core/user-interface-legacy';

export const billingPlanTokenRecord: Record<BillingPlanTier, IconToken> = {
  [BillingPlanTier.Launch]: 'colorIconOptimizeDefault',
  [BillingPlanTier.Scale]: 'colorIconOptimizeDefault',
  [BillingPlanTier.Lead]: 'colorIconOptimizeDefault',
  [BillingPlanTier.Start]: 'colorIconPrimaryDefault',
  [BillingPlanTier.Grow]: 'colorIconScaleDefault',
  [BillingPlanTier.Optimize]: 'colorIconLeadDefault',
};
